// extracted by mini-css-extract-plugin
export default {"products":"mu-z","card":"nu-z","oosMessaging":"ou-z"};